import * as React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Sidebar } from '@/components/layout/sidebar';
import { Topbar } from '@/components/layout/topbar';
import type { SessionInfo } from '@/lib/auth';

/**
 * `_app` — authenticated shell. Every authenticated route lives under
 * this layout. Public routes (login pages) declare their own root and
 * skip this.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context }) => {
    const session = (context as { session: SessionInfo | null }).session;
    if (!session) {
      // The root route already redirects to /login; this is defense in depth.
      throw new Error('Unauthenticated reached _app layout');
    }
    return { session };
  },
  component: AppLayout,
});

function AppLayout() {
  const { session } = Route.useRouteContext();
  const brand = session.role === 'operator' ? 'Operator' : (session.tenant?.legal_name ?? 'Klinika');
  const sub = session.role === 'operator' ? 'pozyskajpacjenta' : (session.tenant?.slug ?? '');

  return (
    <div className="grid h-screen grid-cols-[240px_minmax(0,1fr)]">
      <Sidebar role={session.role} brandLabel={brand} brandSublabel={sub} />
      <div className="flex h-screen min-w-0 flex-col">
        <Topbar session={session} />
        <main className="flex-1 overflow-y-auto bg-surface scrollbar-thin">
          <div className="mx-auto max-w-6xl p-6 md:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
